import Gameplay from "slotworks/model/gameplay/gameplay";
import FreespinRequestPayload from "slotworks/model/gameplay/requests/freespin-request-payload";
import { RequestBuilder } from "slotworks/server/builders/request-builder";

class FreespinRequestBuilder implements RequestBuilder {

    public filter(request: any): boolean {
        return request instanceof FreespinRequestPayload;
    }

    public build(gameplay: Gameplay, request: any) {
        const packet = `<Request verbex="Freespin" />`;

        return packet;
    }
}

export default new FreespinRequestBuilder();
